import { useMemo } from "react";
import type { ImmutableObject } from "@/lib/immutable";
import { createStore, type Store, useStore } from "./store";

export class SessionLocalStorageModel {
	loggedIn: boolean = false;
	fullName: string = "";
	email: string = "";
	deal: string = "";
	dealid: string = "";
	hasPortal: boolean = false;
	hasStorefront: boolean = false;
}

const initialState = new SessionLocalStorageModel();
initialState.deal = window.localStorage.getItem("portal.auth.deal") ?? "";
initialState.dealid = window.localStorage.getItem("portal.auth.dealid") ?? "";
initialState.email = window.localStorage.getItem("portal.auth.deal") ?? "";
initialState.fullName =
	window.localStorage.getItem("portal.auth.fullname") ?? "";
initialState.loggedIn =
	(window.localStorage.getItem("portal.auth.isAuthenticated") ?? "false") ===
	"true";
initialState.hasPortal =
	(window.localStorage.getItem("portal.auth.hasportal") ?? "false") === "true";
initialState.hasStorefront =
	(window.localStorage.getItem("portal.auth.hasstorefront") ?? "false") ===
	"true";
const sessionStateStore = createStore<SessionLocalStorageModel>(initialState);

export function resetSessionState() {
	sessionStateStore.setState(new SessionLocalStorageModel());
	window.localStorage.removeItem("portal.auth.deal");
	window.localStorage.removeItem("portal.auth.dealid");
	window.localStorage.removeItem("portal.auth.email");
	window.localStorage.removeItem("portal.auth.fullname");
	window.localStorage.removeItem("portal.auth.isAuthenticated");
	window.localStorage.removeItem("portal.auth.hasportal");
	window.localStorage.removeItem("portal.auth.hasstorefront");
}

export class SessionState {
	private sessionState: Store<SessionLocalStorageModel>;

	constructor(sessionState: Store<SessionLocalStorageModel>) {
		this.sessionState = sessionState;
	}

	get(): ImmutableObject<SessionLocalStorageModel> {
		return this.sessionState.getState();
	}

	reset() {
		resetSessionState();
	}

	private saveToLocalStorage() {
		window.localStorage.setItem(
			"portal.auth.deal",
			this.sessionState.getState().deal,
		);
		window.localStorage.setItem(
			"portal.auth.dealid",
			this.sessionState.getState().dealid,
		);
		window.localStorage.setItem(
			"portal.auth.email",
			this.sessionState.getState().email,
		);
		window.localStorage.setItem(
			"portal.auth.fullname",
			this.sessionState.getState().fullName,
		);
		window.localStorage.setItem(
			"portal.auth.isAuthenticated",
			this.sessionState.getState().loggedIn.toString(),
		);
		window.localStorage.setItem(
			"portal.auth.hasportal",
			this.sessionState.getState().hasPortal.toString(),
		);
		window.localStorage.setItem(
			"portal.auth.hasstorefront",
			this.sessionState.getState().hasStorefront.toString(),
		);
	}

	set(sessionState: SessionLocalStorageModel) {
		this.sessionState.setState(sessionState);
		this.saveToLocalStorage();
	}
}

export function useSessionState(): SessionState {
	useStore(sessionStateStore);
	return useMemo(() => new SessionState(sessionStateStore), []);
}
